import axiosClient from "@/utils/axios-client";
import { toCamelKeyObject, toSnakeKeyObject } from "@/utils/case";
import {
  PathPickDisconnectProductsRequestBody,
  PathPickOrderRequestBody,
  PathPickRequestsRequestBody,
} from "@/features/pathpick/types/request-body";
import {
  PathPickCreatedOrderResponse,
  PathPickDisconnectJobAccepted,
} from "@/features/pathpick/types/response";

const url = {
  createPathPickOrder: (companyId: number) =>
    `/buyers/${companyId}/pathpick/orders`,
  createPathPickRequests: (companyId: number) =>
    `/buyers/${companyId}/pathpick/requests`,
  requestPathPickDisconnectJob: (companyId: number) =>
    `/buyers/${companyId}/pathpick/requests/disconnect-jobs`,
};

// pathpick 공용 변경(POST/PUT/DELETE) API — 하위 feature 전용 API는 features/*/api에 둔다
export const pathPickMutationApi = {
  // 주문 생성 — 담은 상품 선택 주문과 상품 찾기 단건 주문이 같은 엔드포인트를 쓴다.
  // 가격은 보내지 않는다: 서버가 주문 시점의 판매가를 스냅샷해 저장한다.
  // 배송지는 호출부가 shippingInfoId로 담아 보낸다 — 생략하면 서버가 바이어 기본 배송지를 쓴다.
  // 응답은 생성된 주문 상세다 — 주문 완료 모달이 입금 정보와 주문 id를 여기서 얻으므로
  // 추가 조회 없이 쓸 수 있게 camel로 변환해 돌려준다.
  createPathPickOrder: async (
    companyId: number,
    body: PathPickOrderRequestBody
  ): Promise<PathPickCreatedOrderResponse> => {
    const { data } = await axiosClient.post(
      url.createPathPickOrder(companyId),
      toSnakeKeyObject(body)
    );
    return toCamelKeyObject(data) as PathPickCreatedOrderResponse;
  },
  // 연동/파일 신청을 request_types(NAVER_SYNC / MUSTIT_SYNC / TRENBE_SYNC / CAFE24_SYNC /
  // NAVER_EXCEL / KREAM_EXCEL / KREAM_EXCEL_CONFIRMED_QUANTITY)로 접수하는 일괄 요청.
  // 담은 상품의 신청 플로우, 상품별 처리 내역의 재생성, 주문 상세의 KREAM 입찰용 파일 신청이
  // 같은 엔드포인트를 쓴다 — 대상만 products / orderIds로 갈린다.
  createPathPickRequests: async (
    companyId: number,
    body: PathPickRequestsRequestBody
  ) =>
    await axiosClient.post(
      url.createPathPickRequests(companyId),
      toSnakeKeyObject(body)
    ),
  // 마켓 연동 해제(벌크)를 작업으로 접수 — body.storeNames로 고른 스토어만, 생략하면 연결된 모든 마켓에서 내린다.
  // deleteFromStore=true면 마켓의 상품까지 내린다 — 기본은 연동만 해제.
  // 바로 돌아오고, 결과는 pathPickQueryApi.getPathPickDisconnectJob 으로 끝날 때까지 조회한다.
  requestPathPickDisconnectJob: async (
    companyId: number,
    body: PathPickDisconnectProductsRequestBody,
    deleteFromStore = false
  ) => {
    const { data } = await axiosClient.post(
      url.requestPathPickDisconnectJob(companyId),
      toSnakeKeyObject(body),
      { params: { delete_from_store: deleteFromStore } }
    );
    return toCamelKeyObject(data) as PathPickDisconnectJobAccepted;
  },
};
